/*******************************************************************************
* Licensed Materials - Property of HCL 
* (c) Copyright HCL Technologies Ltd. 2020. All Rights Reserved. 

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/
/**
 * Component that creates a 3D input field
 */

import React from "react";
import PropTypes from "prop-types";
import Text from "./Text";

function Input({
    disabled,
    width,
    height,
    fontColor,
    backgroundColor = "#363636",
    text,
    textSize,
    textSizeDecimal,
    centered = false,
    onClickHandler,
    focused,
    placeholder,
    crop = true,
    aframeClasses,
    ...otherAttributes
}) {
    return (
        <a-entity class="input" {...otherAttributes}>
            <a-plane
                class={aframeClasses}
                onClick={(e) => {
                    if (!disabled) onClickHandler(e);
                }}
                color={backgroundColor}
                width={width}
                height={height}
                opacity={disabled ? "0.5" : "1"}
            >
                <Text
                    crop={crop}
                    reverseCrop
                    text={
                        text
                            ? `${text}${focused ? "|" : ""}`
                            : focused
                            ? "|"
                            : placeholder
                    }
                    position={`${centered ? 0 : (-width * 0.95) / 2} 0 ${
                        height / 200
                    }`}
                    width={width * 0.95}
                    align={centered ? "center" : "left"}
                    size={textSize}
                    sizeDecimal={textSizeDecimal}
                    color={fontColor}
                    opacity={disabled ? "0.5" : "1"}
                />
            </a-plane>
        </a-entity>
    );
}

Input.propTypes = {
    width: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    height: PropTypes.PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired
};

export default Input;
